import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

export const HOME_SEARCH_QUERY = "HOME_SEARCH_QUERY";
export const HOME_SEARCH_RECEIVE = "HOME_SEARCH_RECEIVE";
export const HOME_DISPLAY_RESULT = "HOME_DISPLAY_RESULT";
export const HOME_SEARCH_ERROR = "HOME_SEARCH_ERROR";
export const HOME_USER_GEOLOCATION = 'HOME_USER_GEOLOCATION';
export const HOME_FILTERED_STORES = 'HOME_FILTERED_STORES';

export const setSearchQuery = query => ({
    type: HOME_SEARCH_QUERY,
    payload: {
        query,
    }
})

export const setCoords = (coords) => ({
    type: HOME_USER_GEOLOCATION,
    payload: { coords }
})

export const searchError = error => ({
    type: HOME_SEARCH_ERROR,
    payload: {
        error,
    }
})

export const receive = result => ({
    type: HOME_SEARCH_RECEIVE,
    payload: {
        result,
        showResult: result && result.length > 0
    }
})

export const displayResult = showResult => ({
    type: HOME_DISPLAY_RESULT,
    payload: {
        showResult
    }
})


export const setFilteredStores = filteredStores => ({
    type: HOME_FILTERED_STORES,
    payload: {
        filteredStores
    }
})

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
    const { result } = getState().homeSearch;
    const getResult = () => {
        location.href = opt.searchUrl;
    }
    if (!result || !result.length) {
        return;
    }
    switch (event.keyCode) {
        case 13:
            getResult();
            break;
        default:
            break;
    }
}